import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { BlogService } from 'src/app/blog.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-newsletter-signup-prompt',
  templateUrl: './newsletter-signup-prompt.component.html',
  styleUrls: ['./newsletter-signup-prompt.component.scss']
})
export class NewsletterSignupPromptComponent implements AfterViewInit {

  @ViewChild("formContainer") containerElement: ElementRef;

  environment = environment;

  constructor(
    private blogService: BlogService,
    @Inject(DOCUMENT) public document: Document,
  ) { }

  ngAfterViewInit(): void {
    if (typeof document !== "undefined" && environment.newsletterProvider === "surge") {
      if (Array.from(this.containerElement.nativeElement.children).some(s => s instanceof HTMLScriptElement && s.src === `https://ams.ciphersports.io/form/generate.js?id=27`)) {
        const oldScript: HTMLScriptElement = Array.from(this.containerElement.nativeElement.children).find(s => s instanceof HTMLScriptElement && s.src === `https://ams.ciphersports.io/form/generate.js?id=27`) as HTMLScriptElement;
        oldScript.remove();
      }
      
      let js;
      js = this.document.createElement("script");
      js.src = `https://ams.ciphersports.io/form/generate.js?id=27`;
      (this.containerElement.nativeElement as HTMLElement).appendChild(js);
    }
    

  }

  formSending = false;
  formSent = false;
  formError = false;
  formValid = false;
  email = "";

  sendEmail(): void {

    if (this.formValid) {
      this.formSending = true;
      this.formSent = false;
      this.formError = false;

      this.blogService.addNewsletterEmail(this.email)
        .subscribe(_ => {
          this.formSent = true;
          this.formSending = false;
        }, () => {
          this.formError = true;
          this.formSending = false;
        })
    }
  }

  verifyForm(): void {
    if (!this.email) {
      this.formValid = false;
    } else if (!/.+@.+\..+/.test(this.email)) {
      this.formValid = false;
    } else {
      this.formValid = true;
    }
  }

}
